<template>
  <svg
    v-if="blocks == 4"
    fill="color"
    :height="size"
    :width="size"
    viewBox="0 3 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.74976 12C5.1262 12 5.43784 12.2774 5.49139 12.639L5.49952 12.7498V15.2451C5.49952 15.6592 5.16384 15.9949 4.74976 15.9949C4.37332 15.9949 4.06168 15.7174 4.00813 15.3559L4 15.2451V12.7498C4 12.3357 4.33568 12 4.74976 12Z"
      :fill="color"
    />
    <path
      d="M7.74976 10C8.1262 10 8.43784 10.2774 8.49139 10.639L8.49952 10.7498V15.2451C8.49952 15.6592 8.16384 15.9949 7.74976 15.9949C7.37332 15.9949 7.06168 15.7174 7.00813 15.3559L7 15.2451V10.7498C7 10.3357 7.33568 10 7.74976 10Z"
      :fill="color"
    />
    <path
      d="M10.7498 8C11.1262 8 11.4378 8.27742 11.4914 8.63896L11.4995 8.74976V15.2502C11.4995 15.6643 11.1638 16 10.7498 16C10.3733 16 10.0617 15.7226 10.0081 15.361L10 15.2502V8.74976C10 8.33568 10.3357 8 10.7498 8Z"
      :fill="color"
    />
    <path
      d="M13.7498 6C14.1262 6 14.4378 6.27742 14.4914 6.63897L14.4995 6.74976V15.2502C14.4995 15.6643 14.1638 16 13.7498 16C13.3733 16 13.0617 15.7226 13.0081 15.361L13 15.2502V6.74976C13 6.33568 13.3357 6 13.7498 6Z"
      :fill="color"
    />
  </svg>
  <svg
    v-if="blocks == 3"
    fill="color"
    :height="size"
    :width="size"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.74976 12C5.1262 12 5.43784 12.2774 5.49139 12.639L5.49952 12.7498V15.2451C5.49952 15.6592 5.16384 15.9949 4.74976 15.9949C4.37332 15.9949 4.06168 15.7174 4.00813 15.3559L4 15.2451V12.7498C4 12.3357 4.33568 12 4.74976 12Z"
      :fill="color"
    />
    <path
      d="M7.74976 10C8.1262 10 8.43784 10.2774 8.49139 10.639L8.49952 10.7498V15.2451C8.49952 15.6592 8.16384 15.9949 7.74976 15.9949C7.37332 15.9949 7.06168 15.7174 7.00813 15.3559L7 15.2451V10.7498C7 10.3357 7.33568 10 7.74976 10Z"
      :fill="color"
    />
    <path
      d="M10.7498 8C11.1262 8 11.4378 8.27742 11.4914 8.63896L11.4995 8.74976V15.2502C11.4995 15.6643 11.1638 16 10.7498 16C10.3733 16 10.0617 15.7226 10.0081 15.361L10 15.2502V8.74976C10 8.33568 10.3357 8 10.7498 8Z"
      :fill="color"
    />
    <path
      d="M13.7498 6C14.1262 6 14.4378 6.27742 14.4914 6.63897L14.4995 6.74976V15.2502C14.4995 15.6643 14.1638 16 13.7498 16C13.3733 16 13.0617 15.7226 13.0081 15.361L13 15.2502V6.74976C13 6.33568 13.3357 6 13.7498 6Z"
      fill="whitesmoke"
    />
  </svg>
  <svg
    v-if="blocks == 2"
    fill="color"
    :height="size"
    :width="size"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.74976 12C5.1262 12 5.43784 12.2774 5.49139 12.639L5.49952 12.7498V15.2451C5.49952 15.6592 5.16384 15.9949 4.74976 15.9949C4.37332 15.9949 4.06168 15.7174 4.00813 15.3559L4 15.2451V12.7498C4 12.3357 4.33568 12 4.74976 12Z"
      :fill="color"
    />
    <path
      d="M7.74976 10C8.1262 10 8.43784 10.2774 8.49139 10.639L8.49952 10.7498V15.2451C8.49952 15.6592 8.16384 15.9949 7.74976 15.9949C7.37332 15.9949 7.06168 15.7174 7.00813 15.3559L7 15.2451V10.7498C7 10.3357 7.33568 10 7.74976 10Z"
      :fill="color"
    />
    <path
      d="M10.7498 8C11.1262 8 11.4378 8.27742 11.4914 8.63896L11.4995 8.74976V15.2502C11.4995 15.6643 11.1638 16 10.7498 16C10.3733 16 10.0617 15.7226 10.0081 15.361L10 15.2502V8.74976C10 8.33568 10.3357 8 10.7498 8Z"
      fill="whitesmoke"
    />
    <path
      d="M13.7498 6C14.1262 6 14.4378 6.27742 14.4914 6.63897L14.4995 6.74976V15.2502C14.4995 15.6643 14.1638 16 13.7498 16C13.3733 16 13.0617 15.7226 13.0081 15.361L13 15.2502V6.74976C13 6.33568 13.3357 6 13.7498 6Z"
      fill="whitesmoke"
    />
  </svg>
  <svg
    v-if="blocks == 1"
    fill="color"
    :height="size"
    :width="size"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.74976 12C5.1262 12 5.43784 12.2774 5.49139 12.639L5.49952 12.7498V15.2451C5.49952 15.6592 5.16384 15.9949 4.74976 15.9949C4.37332 15.9949 4.06168 15.7174 4.00813 15.3559L4 15.2451V12.7498C4 12.3357 4.33568 12 4.74976 12Z"
      :fill="color"
    />
    <path
      d="M7.74976 10C8.1262 10 8.43784 10.2774 8.49139 10.639L8.49952 10.7498V15.2451C8.49952 15.6592 8.16384 15.9949 7.74976 15.9949C7.37332 15.9949 7.06168 15.7174 7.00813 15.3559L7 15.2451V10.7498C7 10.3357 7.33568 10 7.74976 10Z"
      fill="darkgray"
    />
    <path
      d="M10.7498 8C11.1262 8 11.4378 8.27742 11.4914 8.63896L11.4995 8.74976V15.2502C11.4995 15.6643 11.1638 16 10.7498 16C10.3733 16 10.0617 15.7226 10.0081 15.361L10 15.2502V8.74976C10 8.33568 10.3357 8 10.7498 8Z"
      fill="darkgray"
    />
    <path
      d="M13.7498 6C14.1262 6 14.4378 6.27742 14.4914 6.63897L14.4995 6.74976V15.2502C14.4995 15.6643 14.1638 16 13.7498 16C13.3733 16 13.0617 15.7226 13.0081 15.361L13 15.2502V6.74976C13 6.33568 13.3357 6 13.7498 6Z"
      fill="darkgray"
    />
  </svg>
</template>

<script>
export default {
  props: {
    blocks: {
      type: String,
      default: "3",
    },
    color: {
      type: String,
      default: "black",
    },
    background: {
      type: String,
      default: "none",
    },
    size: {
      type: String,
      default: "25",
    },
  },
};
</script>
